import PullOutPage from './PullOutPage';
export default PullOutPage;
